import { Avatar as AntAvatar } from 'antd';
import { AvatarProps } from 'antd/lib/avatar';
import cx from 'classnames';
import { forwardRef } from 'react';

import styles from './Avatar.module.less';

interface CustomAvatarProps extends AvatarProps {
  randomizeColor?: boolean;
  color?: string;
  background?: string;
}

export const Avatar = forwardRef<HTMLSpanElement, CustomAvatarProps>(
  ({ children, randomizeColor, style, color, background, ...otherProps }, ref) => {
    const defaultStyles = {
      backgroundColor: background ?? '@blue-0',
      color: color ?? '#262626',
      fontSize: '12px',
    };

    return (
      <AntAvatar
        ref={ref}
        {...otherProps}
        style={{ ...defaultStyles, ...style }}
        className={cx(styles.avatar, otherProps.className)}
      >
        {children}
      </AntAvatar>
    );
  },
);
